// extracted by mini-css-extract-plugin
export default {"main":"Error_main__ZByJn"};